<template>
  <div class="docs__nav">
    <ul class="docs__nav-items">
      <span class="docs__nav-label">On this page</span>
      <li v-for="item in toc" :key="item.id" class="docs__nav-item">
        <a
          v-smooth-scroll
          :href="'#' + item.id"
          class="docs__nav-item-link"
          :class="{ active: `#${item.id}` === $route.hash }"
          >{{ item.name }}</a
        >
        <ul v-if="item.children.length > 0" class="docs__nav-sub-items">
          <li
            v-for="child in item.children"
            :key="child.id"
            class="docs__nav-sub-item"
          >
            <a
              v-smooth-scroll
              :href="'#' + child.id"
              class="docs__nav-sub-item-link"
              :class="{ active: `#${child.id}` === $route.hash }"
              >{{ child.name }}</a
            >
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DocsTOC',
  props: {
    toc: {
      type: Array,
      required: true,
    },
  },
}
</script>
